<div *ngIf="showLoader$ | async" class="ShowHideLoadingPanel">
    <img src="../assets/img/loader.gif" id="imgLoader" class="loadingImage" />
</div>
